module.exports = __webpack_public_path__ + "img/end-decor.8033b46d.png";